import DOMPurify, { type Config } from 'dompurify';

const toHtmlString = (value: unknown) => String(value ?? '');

export const sanitizeHtml = (value: unknown, config?: Config): string => {
	try {
		return DOMPurify.sanitize(toHtmlString(value), config) as string;
	} catch {
		return '';
	}
};

export const sanitizeSvg = (value: unknown): string =>
	sanitizeHtml(value, {
		USE_PROFILES: { svg: true, svgFilters: true },
		FORBID_TAGS: ['script', 'foreignObject'],
	});
